import $ from 'jquery'

$(function() {
  function sanitize(input) {
    const output = input.replace(/<script[^>]*?>.*?<\/script>/gi, '').
           replace(/<[\/\!]*?[^<>]*?>/gi, '').
           replace(/<style[^>]*?>.*?<\/style>/gi, '').
           replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '').
           replace(/&nbsp;/g, '')
    return output
  }

  function replaceAutoLink(str) {
    const urlRegexp = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g; // ']))/;
    if (urlRegexp.test(str)) return str

    const regexpMakeLink = function(all, url, h, href) {
      return '<a href="h' + href + '" rel="noreferrer nofollow noopener" target="_blank">' + url + '</a>'
    }

    return str.replace(urlRegexp, regexpMakeLink)
  }

  function replaceReply() {
    $('.answer-text p').each(function(index, answer) {
      let answerText = $(answer).html()
      if (!answerText) return

      // URL置換処理
      const urlRegexp = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g
      if (urlRegexp.test(answerText)) {
        const regexpMakeUrl = function(all, url, h, href) {
          return '<a href="h' + href + '" class="underline text-blue-600" rel="noreferrer nofollow noopener" target="_blank">' + url + '</a>'
        }

        answerText = answerText.replace(
          urlRegexp,
          '<a href="$1" class="underline text-blue-600" rel="noreferrer nofollow noopener" target="_blank">$1</a>'
        )
      }

      // レスナンバー置換処理
      const linkRegexp = /^&gt;&gt;[0-9]{1,3}/g
      if(linkRegexp.test(answerText)) {
        const answerId = /^&gt;&gt;(\d+)/.test(answerText) ? Number(RegExp.$1) : undefined
        if (!answerId) return

        answerText = answerText.replace(
          linkRegexp,
          `<a href="#answer${answerId}" class="underline text-blue-600">>>${answerId}</a><br>`
        )
      }

      $(answer).html(answerText)
    })
  }
  replaceReply()

  $('.answer-reply').on('click', function() {
    const replyId = $(this).data('id')
    if (!replyId) return

    const textArea = $('#answer_text')
    textArea.val(`>>${Number(replyId)}\n`)
    textArea.focus()
  })
})

